// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ov0a","label":"styles_label__2RvVg"};